// import CartPage from './views/CartPage.vue';

export default [
  // {
  //   path: '/cart',
  //   name: 'cart',
  //   component: CartPage,
  //   meta: {
  //     title: 'Mon Panier',
  //     headerVisible: true,
  //     headerColor: 'default',
  //     requiresAuth: true
  //   }
  // }
];
